// Galerie produit : clic sur miniature = image principale
document.addEventListener('click', function (e) {
  var t = e.target.closest('[data-thumb]');
  if (!t) return;
  var main = document.querySelector('[data-main-image]');
  if (main) main.src = t.dataset.thumb;
});
